"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Item;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Item({
  group,
  slug,
  title,
  icon,
  previous,
  style,
  children
}) {
  let link = "";

  if (group) {
    link += "/" + group;
  }

  if (slug) {
    link += "/" + slug;
  }

  return /*#__PURE__*/_react.default.createElement(_gatsby.Link, {
    to: link,
    className: (0, _classnames.default)({
      "pagination-previous": previous,
      "pagination-next": !previous
    }),
    rel: previous ? "prev" : "next",
    style: style
  }, children, previous ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("i", {
    className: icon
  }), /*#__PURE__*/_react.default.createElement("span", null, title)) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, title), /*#__PURE__*/_react.default.createElement("i", {
    className: icon
  })));
}

Item.propTypes = {
  group: _propTypes.default.string,
  slug: _propTypes.default.string,
  title: _propTypes.default.string,
  icon: _propTypes.default.string,
  previous: _propTypes.default.bool.isRequired,
  style: _propTypes.default.object,
  children: _propTypes.default.any
};
Item.defaultProps = {
  previous: false
};